import {
  ArrowLeftOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SelectOutlined
} from "@ant-design/icons"
import {
  Avatar,
  Button,
  Card,
  Flex,
  Space,
  Tag,
  Tooltip,
  Typography
} from "antd"
import React from "react"

import { empty } from "../../../../../../constants/placeholders"
import { type Album } from "../../../../../Album/types/album.types.ts"

const { Title, Text } = Typography

interface ProjectViewAlbumSectionInfoProps {
  album: Album
  editAllowed: boolean
  addFilesAllowed: boolean
  onBackClick: () => void
  onSelectFileClick: () => void
  onAddFileClick: () => void
  onEditClick: () => void
  deleteAllowed: boolean
  onDeleteClick: () => void
}

export function ProjectViewAlbumSectionInfo({
  album,
  editAllowed,
  addFilesAllowed,
  onBackClick,
  onEditClick,
  onSelectFileClick,
  onAddFileClick,
  deleteAllowed,
  onDeleteClick
}: ProjectViewAlbumSectionInfoProps) {
  return (
    <Card classNames={{ body: "p-2" }}>
      <Flex justify="space-between" align="center" gap={12}>
        <Flex align="center" gap={12} className="min-w-0 flex-1">
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={onBackClick}
            className="flex-shrink-0"
          />

          <Tooltip title={album.name}>
            <Title level={4} className="m-0 !mb-0 truncate max-w-xs">
              {album.name}
            </Title>
          </Tooltip>

          <Tag
            color={album.is_visible_to_customer ? "green" : "red"}
            className="m-0 flex-shrink-0"
          >
            {album.is_visible_to_customer ? "Visible" : "Hidden"}
          </Tag>
        </Flex>

        <Flex gap={8} className="flex-shrink-0">
          {addFilesAllowed && (
            <>
              <Button
                type="primary"
                icon={<SelectOutlined />}
                onClick={onSelectFileClick}
              >
                Select Files
              </Button>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={onAddFileClick}
              >
                Files
              </Button>
            </>
          )}
          {editAllowed && (
            <Button icon={<EditOutlined />} onClick={onEditClick}>
              Edit
            </Button>
          )}
          {deleteAllowed && (
            <Button danger icon={<DeleteOutlined />} onClick={onDeleteClick}>
              Delete
            </Button>
          )}
        </Flex>
      </Flex>
      <Space>
        <Flex align="center" gap={4} className="flex-shrink-0">
          <Text type={"secondary"}>Created by:</Text>

          {album?.created_by_name ? (
            <>
              <Text type={"secondary"}>{album?.created_by_name}</Text>
              <Avatar size="small">{album?.created_by_name.charAt(0)}</Avatar>
            </>
          ) : (
            empty
          )}
        </Flex>
        <Text type={"secondary"}>|</Text>
        <Text
          type="secondary"
          className="text-xs flex-shrink-0 whitespace-nowrap"
        >
          {album?.created}
        </Text>
        <Text type={"secondary"}>|</Text>
        <Text
          type="secondary"
          className="text-xs flex-shrink-0 whitespace-nowrap"
        >
          {album?.attachments_count} files
        </Text>
      </Space>
    </Card>
  )
}
